import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h3>Sorry, 404 Not Found</h3>
        </div>
    );
};

export default NotFound;